import React, { Component } from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { Typography, Grid, Button} from "@material-ui/core";
import {
    getUser,
    getQualificationCategories,
    setUpdateQualInfo,
    setSnackBarState,
    submitUpdatedProfile,
    setUpdateInfo,
    getProfile,
    getAllUsers,
    updateSelectedUserPassword,
    getUserTypes,
    getDepartments,
    getAreas,
    getLoggedUID,
    generateQualAlerts,
    uploadFile,
    getUserJobpacks
} from "./actions";
import {
    selectUserProfile,
    selectQualificationsPerCategory,
    selectPostFail,
    selectPostSuccess,
    selectUsers,
    selectProfile,
    selectLoggedProfile,
    selectUserTypes,
    selectAreas,
    selectDepartments,
    canDelete,
    canUpdate,
    canCreate,
    canRead,
    selectAllUsersDetails,
    selectRequesting,
    selectUserMapsData,
    selectNickNames,
    selectAllNickNames
} from "./selectors";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

import {
    PersonalInfo,
    SecurityInfo,
    RegisteredAreasDepartments,
    UpdateProfileSnackbar,
    MaxFileSizeSnackbar,
    ViewQualificationInfoModal,
    EditQualificationInfoModal,
    QualificationInfoPaper,
    UserAnalytics
} from "./Components";
import styled from "styled-components";
import PrintIcon from '@material-ui/icons/Print';
import Box from '@material-ui/core/Box';
import ReactToPrint from "react-to-print";
import moment from "moment";
import _ from "lodash";

const ParentDiv = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;
class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedQualification: false,
            viewQualificationModalState: false,
            editQualificationModalState: false,
        };
        props.getLoggedUID();
        if (props.location.pathname.split("/")[1] === "profile") {
            props.getProfile();
        } else {
            props.getUser(props.match.params.uid);
        }

        props.getQualificationCategories();
        props.getAllUsers();
        props.getUserTypes();
        props.getDepartments();
        props.getAreas();
        props.getUserJobpacks();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.userProfile !== this.props.userProfile) {
            this.setState({ profile: this.props.userProfile });
        }
    }

    render() {
        const { userProfile, qualsPerCategory, userJobpacks, areas, departments, loggedInUserProfile } = this.props;
        
        const {
            selectedQualification,
            viewQualificationModalState,
            editQualificationModalState,
        } = this.state;

        //check if user belongs to loggedIn user areas & departments 
        //get users belonging to logged in user areas & depts    
        let allAreas = areas && Object.values(areas).map((e)=> { return e })
        let allDepartments = departments && Object.values(departments).map((e)=> { return e })
        let loggedInUserProfileAreas = loggedInUserProfile.areas
        let loggedInUserProfileDepts = loggedInUserProfile.departments

        if(loggedInUserProfileAreas === false || loggedInUserProfileAreas === undefined){
            loggedInUserProfileAreas = allAreas
        }

        if(loggedInUserProfileDepts === false  || loggedInUserProfileDepts === undefined){
            loggedInUserProfileDepts = allDepartments
        }
        
        let validationArea = []
        let validationDept = []
        var isValidUser = false;
        let userProfileAreas = userProfile.areas
        let userProfileDept = userProfile.departments

        if(userProfileAreas === null  || userProfileAreas === undefined){
            validationArea = _.intersection(allAreas,loggedInUserProfileAreas)
        }else{
            validationArea = _.intersection(userProfileAreas,loggedInUserProfileAreas)
        }
        
        if(userProfileDept === null || userProfileDept === undefined){
            validationDept = _.intersection(allDepartments,loggedInUserProfileDepts)
        }else {
            validationDept = _.intersection(userProfileDept,loggedInUserProfileDepts)
        } 
        if ( validationArea.length !== 0 && validationDept.length !== 0) {
            isValidUser = true;                 
        }
        return (
            userProfile && (
                <div ref={(el) => (this.componentRef = el)}>
                <StyledCard style={{paddingBottom:"45px"}}>
                    <>
                        <ParentDiv
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                           
                        >   
                            <div style={{ width: '100%' }}>
                            <StyledHeader
                                        style={{
                                            height: "fit-content",
                                            width: "100%",
                                            paddingTop: "5px",
                                            backgroundColor: "#0188cc"
                                        }}
                                    >   
                            <Box display="flex" >
                                <Box  flexGrow={1} style={{marginTop:"10px"}}>
                                <Typography variant="display1" style={{color: "white"}} >
                                                {userProfile.first_name}{" "}
                                                {userProfile.last_name} 
                                </Typography>
                                </Box>
                                {/* <Box style={{paddingRight:"15px"}}>
                                <Button variant="contained" style={{backgroundColor:"#FFA500", color:"white"}}>Edit</Button>
                                </Box> */}
                                <Box style={{marginTop:"8px"}}>
                                <ReactToPrint
                                        style={{}}
                                        onBeforePrint={() => {
                                            setTimeout(undefined, 2000);
                                            document.title =
                                                "User Info - " +
                                                moment().format("DD-MM-YYYY");
                                        }}
                                        onAfterPrint={() => {}}
                                        trigger={() => (
                                            <Button
                                                style={{
                                                    float: "right",
                                                    color: "#0188cc",
                                                    background: "white",
                                                }}
                                                size="small"
                                            >
                                                <PrintIcon /> 
                                            </Button>
                                        )}
                                        content={() => this.componentRef}
                                    />
                                </Box>
                            </Box>
                            </StyledHeader>
                            </div>
                            {/* {this.props.location.pathname.split("/")[1] !==
                                "profile" && (
                                <div
                                    style={{
                                        borderWidth: "0px",
                                        height: "84px",
                                        backgroundColor: "#F7F7F7",
                                        paddingRight: "37px",
                                        paddingTop: "14px",
                                    }}
                                >
                                    <Typography variant="body2">
                                        <b> Change User </b>
                                    </Typography>
                                    {users && (
                                        <Select
                                            style={{
                                                marginTop: 1,
                                                minWidth: 150,
                                            }}
                                            value={userProfile.uid}
                                            onChange={(event) => {
                                                this.props.getUser(
                                                    event.target.value
                                                );
                                            }}
                                        >
                                            {users.map((e) => {
                                                return (
                                                    <MenuItem
                                                        key={e.uid}
                                                        value={e.uid}
                                                    >
                                                        {e.fname} {e.lname}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    )}
                                </div>
                            )} */}
                        </ParentDiv>
                        <StyledContent style={{paddingBottom:"35px"}}>
                            <StyledViewContainer>
                                {!qualsPerCategory && (
                                    <Grid container spacing={6}>
                                        <Grid item lg={6} md={12} sm={12}>
                                            <PersonalInfo
                                                nickNames = {this.props.nickNames}
                                                userProfile={
                                                    this.props.userProfile
                                                }
                                                loggedInUserProfile={
                                                    this.props.loggedInUserProfile
                                                }
                                                setState={(key, value) =>
                                                    this.setState({
                                                        [key]: value,
                                                    })
                                                }
                                                submitUpdatedProfile={
                                                    this.props
                                                        .submitUpdatedProfile
                                                }
                                                userProfileKeys={
                                                    this.props.userProfileKeys
                                                }
                                                userTypes={this.props.userTypes}
                                                departments={
                                                    this.props.departments
                                                }
                                                areas={this.props.areas}
                                                canUpdate={this.props.canUpdate}
                                                canDelete={this.props.canDelete}
                                                canCreate={this.props.canCreate}
                                                loggedUID={
                                                    this.props.loggedProfile.uid
                                                }
                                                requesting = {this.props.requesting}
                                                updateSelectedUserPassword={
                                                    this.props
                                                        .updateSelectedUserPassword
                                                }
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={12} sm={12}>
                                        <UserAnalytics userJobpacks={userJobpacks}/>
                                            <SecurityInfo
                                                userProfile={
                                                    this.props.userProfile
                                                }
                                                setSnackBarState={
                                                    this.props.setSnackBarState
                                                }
                                                setUpdatedSecurityInfo={
                                                    this.props.setUpdateInfo
                                                }
                                                updateSelectedUserPassword={
                                                    this.props
                                                        .updateSelectedUserPassword
                                                }
                                                loggedUser={
                                                    this.props.loggedProfile
                                                }
                                                canUpdate={this.props.canUpdate}
                                                canDelete={this.props.canDelete}
                                                canCreate={this.props.canCreate}
                                                loggedUID={
                                                    this.props.loggedProfile.uid
                                                }
                                                userTypes={this.props.userTypes}
                                                submitUpdatedProfile={
                                                    this.props
                                                        .submitUpdatedProfile
                                                }
                                            />
                                            <RegisteredAreasDepartments
                                                  userProfile={
                                                    this.props.userProfile
                                                }
                                                setSnackBarState={
                                                    this.props.setSnackBarState
                                                }
                                                setUpdatedSecurityInfo={
                                                    this.props.setUpdateInfo
                                                }
                                                updateSelectedUserPassword={
                                                    this.props
                                                        .updateSelectedUserPassword
                                                }
                                                loggedUser={
                                                    this.props.loggedProfile
                                                }
                                                canUpdate={this.props.canUpdate}
                                                canDelete={this.props.canDelete}
                                                canCreate={this.props.canCreate}
                                                loggedUID={
                                                    this.props.loggedProfile.uid
                                                }
                                               departments={
                                                this.props.departments
                                                }
                                                areas={this.props.areas}
                                                submitUpdatedProfile={
                                                    this.props
                                                        .submitUpdatedProfile
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            
                                {qualsPerCategory && (
                                    <Grid container spacing={3}>
                                        
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <PersonalInfo
                                                nickNames = {this.props.nickNames}
                                                userProfile={
                                                    this.props.userProfile
                                                }
                                                loggedInUserProfile={
                                                    this.props.loggedInUserProfile
                                                }
                                                setState={(key, value) =>
                                                    this.setState({
                                                        [key]: value,
                                                    })
                                                }
                                                submitUpdatedProfile={
                                                    this.props
                                                        .submitUpdatedProfile
                                                }
                                                userProfileKeys={
                                                    this.props.userProfileKeys
                                                }
                                                userTypes={this.props.userTypes}
                                                departments={
                                                    this.props.departments
                                                }
                                                areas={this.props.areas}
                                                canUpdate={this.props.canUpdate}
                                                canDelete={this.props.canDelete}
                                                canCreate={this.props.canCreate}
                                                loggedUID={
                                                    this.props.loggedProfile.uid
                                                }
                                                requesting = {this.props.requesting}
                                                updateSelectedUserPassword={
                                                    this.props
                                                        .updateSelectedUserPassword
                                                }
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <UserAnalytics userJobpacks={userJobpacks}/>
                                            <SecurityInfo
                                                userProfile={
                                                    this.props.userProfile
                                                }
                                                setSnackBarState={
                                                    this.props.setSnackBarState
                                                }
                                                setUpdatedSecurityInfo={
                                                    this.props.setUpdateInfo
                                                }
                                                updateSelectedUserPassword={
                                                    this.props
                                                        .updateSelectedUserPassword
                                                }
                                                loggedUser={
                                                    this.props.loggedProfile
                                                }
                                                canUpdate={this.props.canUpdate}
                                                canDelete={this.props.canDelete}
                                                canCreate={this.props.canCreate}
                                                loggedUID={
                                                    this.props.loggedProfile.uid
                                                }
                                                userTypes={this.props.userTypes}
                                                submitUpdatedProfile={
                                                    this.props
                                                        .submitUpdatedProfile
                                                }
                                            />
                                            <RegisteredAreasDepartments
                                                  userProfile={
                                                    this.props.userProfile
                                                }
                                                setSnackBarState={
                                                    this.props.setSnackBarState
                                                }
                                                setUpdatedSecurityInfo={
                                                    this.props.setUpdateInfo
                                                }
                                                updateSelectedUserPassword={
                                                    this.props
                                                        .updateSelectedUserPassword
                                                }
                                                loggedUser={
                                                    this.props.loggedProfile
                                                }
                                                canUpdate={this.props.canUpdate}
                                                canDelete={this.props.canDelete}
                                                canCreate={this.props.canCreate}
                                                loggedUID={
                                                    this.props.loggedProfile.uid
                                                }
                                               departments={
                                                this.props.departments
                                                }
                                                areas={this.props.areas}
                                                submitUpdatedProfile={
                                                    this.props
                                                        .submitUpdatedProfile
                                                }
                                            />
                                        </Grid>
                                        {isValidUser ? <>
                                        {qualsPerCategory.map(
                                            (category_info, i) => {
                                                return (
                                                    
                                                    <Grid 
                                                        item
                                                        lg={6}
                                                        md={6}
                                                        sm={6}
                                                        xs={6}
                                                    >
                                                        <QualificationInfoPaper
                                                            key={i}
                                                            canUpdate={this.props.canUpdate}
                                                            category_info={
                                                                category_info
                                                            }
                                                            setViewQualificationModalState={(
                                                                state
                                                            ) =>
                                                                this.setState({
                                                                    viewQualificationModalState: state,
                                                                })
                                                            }
                                                            setEditQualificationModalState={(
                                                                state
                                                            ) =>
                                                                this.setState({
                                                                    editQualificationModalState: state,
                                                                })
                                                            }
                                                            setSelectedQualification={(
                                                                qualification
                                                            ) => {
                                                                this.setState({
                                                                    selectedQualification: qualification,
                                                                });
                                                            }}
                                                        />
                                                    </Grid>
                                                );
                                            }
                                        )}
                                        </>
                                        : '' }
                                    </Grid>
                                )}
                                <ViewQualificationInfoModal
                                    selectedQualification={
                                        selectedQualification
                                    }
                                    modalState={viewQualificationModalState}
                                    setSelectedQualification={(qualification) =>
                                        this.setState({
                                            selectedQualification: qualification,
                                        })
                                    }
                                    setModalState={(state) =>
                                        this.setState({
                                            viewQualificationModalState: state,
                                        })
                                    }
                                    setEditQualificationModalState={(state) =>
                                        this.setState({
                                            editQualificationModalState: state,
                                        })
                                    }
                                    canUpdate={this.props.canUpdate}
                                />
                                <EditQualificationInfoModal
                                    modalState={editQualificationModalState}
                                    setModalState={(state) =>
                                        this.setState({
                                            editQualificationModalState: state,
                                        })
                                    }
                                    selectedQualification={
                                        selectedQualification
                                    }
                                    setSelectedQualification={(qualification) =>
                                        this.setState({
                                            selectedQualification: qualification,
                                        })
                                    }
                                    setUpdateQualInfo={
                                        this.props.setUpdateQualInfo
                                    }
                                    userUID={userProfile.uid}
                                    canUpdate={this.props.canUpdate}
                                    uploadFile={this.props.uploadFile}
                                />

                                <UpdateProfileSnackbar
                                    postSuccess={this.props.postSuccess}
                                    postFail={this.props.postFail}
                                    setSnackBarState={
                                        this.props.setSnackBarState
                                    }
                                />
                                <MaxFileSizeSnackbar
                                    fileMaxSizeSnackbar={
                                        this.state.fileMaxSizeSnackbar
                                    }
                                    setState={() =>
                                        this.setState({
                                            fileMaxSizeSnackbar: false,
                                        })
                                    }
                                />
                            </StyledViewContainer>
                        </StyledContent>
                    </>
                </StyledCard>
                </div>
            )
        );
    }
}
export default hot(module)(
    connect(
        (store, props) => {
            return {
                userProfile:
                    props.location.pathname.split("/")[1] === "profile"
                        ? selectProfile(store)
                        : selectUserProfile(store),
                loggedInUserProfile: selectProfile(store),
                qualsPerCategory: selectQualificationsPerCategory(store),
                postFail: selectPostFail(store),
                postSuccess: selectPostSuccess(store),
                users: selectUsers(store),
                userTypes: selectUserTypes(store),
                departments: selectDepartments(store),
                areas: selectAreas(store),
                canRead: canRead(store),
                loggedProfile: selectLoggedProfile(store),
                canUpdate: canUpdate(store),
                canCreate: canCreate(store),
                canDelete: canDelete(store),
                allUsersData: selectAllUsersDetails(store),
                requesting: selectRequesting(store),
                userJobpacks: selectUserMapsData(store),
                allNickNames: selectNickNames(store),
                nickNames : selectAllNickNames(store)
            };
        },
        {
            getUser,
            getQualificationCategories,
            setUpdateQualInfo,
            submitUpdatedProfile,
            setSnackBarState,
            setUpdateInfo,
            getProfile,
            getAllUsers,
            updateSelectedUserPassword,
            getUserTypes,
            getDepartments,
            getAreas,
            getLoggedUID,
            generateQualAlerts,
            uploadFile,
            getUserJobpacks,
        }
    )(UserProfile)
);
